import { ReviewNewHome } from './review-new-home.component';

export { ReviewNewHome };
